module.exports = __webpack_public_path__ + "static/media/ETH.22a26a8d.svg";